import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  StyledGridControls,
  ButtonContainer,
  PatternHeader,
  TextContainer,
  Text,
} from "./GridControlsStyles";
import Button from "../../../UI/Button/CustomButtonLeftPanelBlue";
import { setHeatMapDisplay } from "../../../../redux/slices/display";
import AnimatedMessage from "../../../UI/AnimatedMessage/AnimatedMessage";
import SavedPatterns from "../../DetectionPreviewColdStart/SavedPatterns/SavedPatterns";
import { useDetectedPatternData } from "../DetectedPatterns/hooks/useDetectedPatternData";
import filterForDuplicatePatterns from "../DetectedPatterns/utils/filterForDuplicatePatterns";
import SelectedPatterns from "../../DetectionPreviewToolbar/SelectedPatterns/SelectedPatterns";

export default function GridControls({ selectedPatternData }) {
  // Redux dispatch function
  const dispatch = useDispatch();

  // Select from redux store
  const detectingPatterns = useSelector(
    ({ detectedPatterns }) => detectedPatterns.fetching
  );
  const branch = "drawModel";

  const patternData = useDetectedPatternData();

  const filteredPatternData = filterForDuplicatePatterns(
    patternData,
    selectedPatternData
  );

  const header = detectingPatterns ? (
    <AnimatedMessage>Detecting patterns</AnimatedMessage>
  ) : (
    "Detection complete"
  );

  const count = filteredPatternData.length + " patterns found";

  return (
    <StyledGridControls>
      {
        {
          selectPattern: <SelectedPatterns />,
          drawModel: <SavedPatterns />,
        }[branch]
      }

      <TextContainer>
        <PatternHeader>{header}</PatternHeader>
        <Text>{count}</Text>
      </TextContainer>

      <ButtonContainer>
        <Button
          disabled={detectingPatterns}
          onClick={() => dispatch(setHeatMapDisplay())}
        >
          Start again
        </Button>
      </ButtonContainer>
    </StyledGridControls>
  );
}
